"use strict";const o=require("react"),t=e=>{o.useEffect(()=>(e?document.body.style.overflow="hidden":document.body.style.overflow="",()=>{document.body.style.overflow=""}),[e])};module.exports=t;
//# sourceMappingURL=useBodyScrollLock.js.map
